import { matchPath } from 'react-router-dom';

const STANDALONE_PAGES = ['/report', '/advise/shared', '/score'];

const SIGN_IN_PAGES = ['/login', '/reset'];

export const UNPROTECTED_ROUTES: readonly string[] = [
  ...STANDALONE_PAGES,
  ...SIGN_IN_PAGES,
  '/portal/offline',
  '/welcome',
  '/authenticate-user',
  '/mfa'
];

// The router's own matching, so letter case or a trailing slash cannot put a page it renders on the wrong side.
const matchesAny = (routes: readonly string[], pathname: string): boolean =>
  routes.some((route) => matchPath(route, pathname) !== null);

export const isStandalonePage = (pathname: string): boolean => matchesAny(STANDALONE_PAGES, pathname);

export const isSignInPage = (pathname: string): boolean => matchesAny(SIGN_IN_PAGES, pathname);

export const isUnprotectedRoute = (pathname: string): boolean => matchesAny(UNPROTECTED_ROUTES, pathname);
